import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './style.css';

// Virtual scroller for large lists
import VueVirtualScroller from 'vue-virtual-scroller';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';

// Highlight.js themes
import 'highlight.js/styles/github.css';
import 'highlight.js/styles/github-dark.css';

// Custom directives
import { vHighlight } from './directives/highlight.js';

const app = createApp(App);

app.use(router);
app.use(VueVirtualScroller);
app.directive('highlight', vHighlight);

app.mount('#app');
